import BaseLayer from "./BaseLayer";
import {plotTileMotionHelper} from "../utils/map_utils";

class StitchRound1TileMotionv2 extends BaseLayer {

    id = "stitchRound1TileMotionv2";
    label = "Tiles Moved";
    defaultVisible = this.props.tileViewerState[this.id];
    draw = () => new Promise((resolve, reject) => {
        let {stitchR1TileMotion, textColor} = this.props;
        plotTileMotionHelper(stitchR1TileMotion, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchRound1TileMotionv2;
